import { render } from "./DetailMultiple.vue?vue&type=template&id=7b363846"
import script from "./DetailMultiple.vue?vue&type=script&lang=js"
export * from "./DetailMultiple.vue?vue&type=script&lang=js"

import "./DetailMultiple.vue?vue&type=style&index=0&id=7b363846&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__